// extracted by mini-css-extract-plugin
module.exports = {"container":"e_5r","withContent":"e_6r","content":"e_7r","iconBox":"e_8r","icon":"e_9r","hidden":"e_-r"};